import { $http } from '@/utils';
import { kebabCase } from 'lodash';
import { MD5 } from 'crypto-js';

/**
 * @namespace Service
 * @class File
 * @exports Service/Site
 * @description API File Service
 * @date 2023/01/19
 * @license no license
 * @copywrite Answers In Retirement Limited
 */
export default class Site {
	/**
	 * @name getDbContent
	 * @description Get db content
	 * @returns {Object} Promise a http response
	 */
	static getDbContent(name, domain = 'default', cache = true) {
		const version = process.env?.VUE_APP_VERSION || null;
		return $http.get(`cms/db-content/${name}/${version}`, {
			cache,
			cachePath: `db-content-${kebabCase(name)}-${version}-${domain}`
		});
	}

	/**
	 * @name getWhiteLabelConfig
	 * @description Get white label config
	 * @param {String} id The white label UUID
	 * @param {String} domain The domain
	 * @param {Boolean} cache Whether to use cache
	 * @returns {Object} Promise a http response
	 */
	static getWhiteLabelConfig(id, domain = 'default', cache = true) {
		const cacheHash = MD5(JSON.stringify({ payload: { id }, domain })).toString();
		return $http.get(`cms/ltv-white-label/${id}?cacheHash=${cacheHash}`, {
			cache,
			cachePath: `table-cms-ltv-white-label-${cacheHash}`
		});
	}
}
